import { render, staticRenderFns } from "./ModalAlertError.vue?vue&type=template&id=086acb56&scoped=true"
import script from "./ModalAlertError.vue?vue&type=script&lang=js"
export * from "./ModalAlertError.vue?vue&type=script&lang=js"
import style0 from "./ModalAlertError.vue?vue&type=style&index=0&id=086acb56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086acb56",
  null
  
)

export default component.exports